import {Workbox} from "workbox-window";

// Export a singleton Workbox instance
let wb: Workbox | null = null;

export function getWorkbox(): Workbox | null {
  if (!("serviceWorker" in navigator)) return null;

  if (!wb) {
    wb = new Workbox("/service-worker.js", {scope: "/"});
  }

  return wb;
}
